// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Js_dict from "../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";

var validationsData = {
  validations: [{
      validation_type: "SEGMENT_VALIDATION",
      segment_names: []
    }]
};

function toCheckBoxOptions(names) {
  return List.map((function (name) {
                return {
                        key: name,
                        value: name,
                        text: name
                      };
              }), names);
}

function makeValidationsPayload(validationState) {
  var validations = Belt_Array.keepMap(validationState.selectedValidations, (function (validationType) {
          var segmentInput = Js_dict.get(validationState.segmentInputs, validationType);
          if (segmentInput === undefined) {
            return ;
          }
          if (segmentInput === "") {
            return ;
          }
          var segments = Belt_Array.keep(Belt_Array.map(segmentInput.split(","), (function (s) {
                      return s.trim().toLowerCase();
                    })), (function (s) {
                  return s !== "";
                }));
          if (segments.length !== 0) {
            return {
                    validation_type: validationType,
                    segment_names: segments
                  };
          }
          
        }));
  if (validations.length !== 0) {
    return validations;
  }
  
}

function getInitialValidationState(savedValidations) {
  if (savedValidations === undefined) {
    return {
            selectedValidations: [],
            segmentInputs: {}
          };
  }
  var selectedValidations = Belt_Array.map(savedValidations, (function (v) {
          return v.validation_type;
        }));
  var segmentInputs = {};
  Belt_Array.forEach(savedValidations, (function (validation) {
          var segmentString = Belt_Array.joinWith(validation.segment_names, ", ", (function (s) {
                  return s;
                }));
          segmentInputs[validation.validation_type] = segmentString;
          
        }));
  return {
          selectedValidations: selectedValidations,
          segmentInputs: segmentInputs
        };
}

export {
  validationsData ,
  toCheckBoxOptions ,
  makeValidationsPayload ,
  getInitialValidationState ,
  
}
/* No side effect */
